<template>
    <div>
        <async-items-loader :task="task" :num-items="reportPosts.length">
            This report has no posts.
        </async-items-loader>
        <report-post
                v-for="reportPost in reportPosts"
                :key="reportPost.id"
                :report-post="reportPost"
                v-model:comment="reportPost.comment"
                class="q-my-md"
                @trashed="trash"
                @restored="restore"
        />
        <div v-show="total" class="q-pa-sm flex flex-center bg-white q-mt-md">
            <pagination
                    v-model="page"
                    :total="total"
                    :per-page="limit"
                    direction-links
                    boundary-links
                    class="bg-white"
            />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {
  ReportPost as ReportPostType,
  QueryResult,
  ReportPostFilters,
} from '@/type';
import AsyncItemsLoader from '@/components/item/AsyncItemsLoader.vue';
import Pagination from '@/components/pagination/Pagination.vue';
import repository from './report-post-repository';
import ReportPost from './ReportPost.vue';

interface Data {
  task: Promise<QueryResult>|null,
  page: number,
  limit: number,
  total: number,
  reportPosts: ReportPostType[],
}

export default defineComponent({
  emits: ['restored', 'trashed'],
  components: { AsyncItemsLoader, ReportPost, Pagination },
  props: {
    reportId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
      page: 1,
      limit: 10,
      total: 0,
      reportPosts: [],
    };
  },
  computed: {
    offset(): number {
      return (this.page - 1) * this.limit;
    },
    filters(): ReportPostFilters {
      return {
        offset: this.offset,
        limit: this.limit,
      };
    },
  },
  watch: {
    reportId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
    filters: {
      handler() {
        this.load();
      },
      deep: true,
    },
    page() {
      if (window.scroll) {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      }
    },
  },
  methods: {
    load() {
      this.task = repository.findAll(this.reportId, this.filters);
      this.task.then((result: QueryResult) => {
        this.total = result.total;
        this.reportPosts = (result.items as ReportPostType[]);
      });
    },
    trash(reportPost: ReportPostType) {
      const index = this.reportPosts.findIndex(rp => rp.id === reportPost.id);
      if (index >= 0) {
        this.reportPosts.splice(index, 1, reportPost);
        this.$emit('trashed', reportPost);
      }
    },
    restore(reportPost: ReportPostType) {
      const index = this.reportPosts.findIndex(rp => rp.id === reportPost.id);
      if (index >= 0) {
        this.reportPosts.splice(index, 1, reportPost);
        this.$emit('restored', reportPost);
      }
    },
  },
});
</script>
